import React, { useState, useEffect } from "react";
import { Container, FormControl, Select, Card, Button, Typography, Grid, CardActions, LinearProgress, MenuItem, Switch } from '@mui/material';
import { useNavigate, useParams } from "react-router-dom";
import CommonListHeader from "components/layout/list/header";
import { useSelector, useDispatch } from 'react-redux'
import { privateDBCreate, } from 'api/privatedb';
import { usePrivateDBEditMutation, usePrivateDBDetailsQuery, useAssignTireMutation } from "services/privatedb";
import { useUserCreateMutation, useUserCognitoMutation, useUserListQuery, useUserDetailsQuery } from 'services/user';

const PrivateDBAssign = (props) => {

    const navi = useNavigate();
    const dispatch = useDispatch();
    const { id } = useParams();
    const privateDB = useSelector(state => state.privateDB.create);
    const [disableButton, setDisableButton] = useState(false);
    const [privateDBEditMutation, { isLoading: isUpdating }] = usePrivateDBEditMutation();
    const [assignTire, { isLoading: assignLoading }] = useAssignTireMutation();

    const handleCancel = () => {
        navi("/privatedb/list")
    }

    const { privateDBDetails } = usePrivateDBDetailsQuery({ id: id },
        {
            selectFromResult: ({ data }) => ({
                privateDBDetails: data || {},
            })
        }
    );

    const { userList } = useUserListQuery({},
        {
            //: !privateDBDetails?.userId,
            selectFromResult: ({ data }) => ({
                userList: data || [],
            })
        }
    );

    const { userDetails } = useUserDetailsQuery({ id: privateDB.userId },
        {
            skip: !privateDB?.userId,
            selectFromResult: ({ data }) => ({
                userDetails: data || {},
            })
        }
    );

    const onSave = () => {
        setDisableButton(true);
        var record = {
            "doc": {
                userId: privateDB.userId,
                id: id
            }

        }




        privateDBEditMutation(record)
            .unwrap()
            .then(result => {

                setTimeout(() => {
                    var assign = {
                        "name": userDetails.firstName,
                        "phone": userDetails.phone,
                        "dot": id
                    }
                    console.log(assign);
                    assignTire(assign)
                        .unwrap()
                        .then(res => {
                            console.log(res);
                            setDisableButton(false);
                            navi("/privatedb/list");
                        })
                        .catch(err => {
                            console.log("error");
                            setDisableButton(false);
                            navi("/privatedb/list");
                        })

                }, 5000)
            })
            .catch(err => {
                setTimeout(() => {
                    setDisableButton(false);
                    navi("/privatedb/list");
                }, 5000)
            })
    }

    return (
        <React.Fragment>
            <CommonListHeader value={{ title: `Edit PrivateDB: ${privateDBDetails.case_name}`, description: "You are editing PrivateDB details." }} />
            <Container maxWidth={'md'}>
                <Card>
                    {disableButton ? <LinearProgress /> : ''}
                    <Container maxWidth={false} sx={{ paddingTop: "10px" }}>

                        <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px" }}>
                            <Grid item md={3}>
                                <Typography variant="body1">DOT Number</Typography>
                            </Grid>
                            <Grid item md={9}>
                                <Typography variant="body1">{privateDBDetails?.dot || ""}</Typography>
                            </Grid>
                        </Grid>
                        <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px" }}>
                            <Grid item md={3}>
                                <Typography variant="body1">Assign To</Typography>
                            </Grid>
                            <Grid item md={9}>
                                <FormControl fullWidth>
                                    <Select
                                        value={privateDB?.userId || ''}
                                        onChange={(event) => dispatch(privateDBCreate({ userId: event.target.value }))}
                                    >
                                        {userList?.map((o, i) =>
                                            <MenuItem key={i} value={o.id}>{`${o.firstName} ${o.lastName}`}</MenuItem>
                                        )}
                                    </Select>
                                </FormControl>
                            </Grid>
                        </Grid>
                    </Container>
                    <CardActions sx={{ padding: "15px" }}>
                        <Button
                            disabled={disableButton}
                            variant="contained"
                            color='primary'
                            type="submit"
                            onClick={() => onSave()}
                        >
                            Submit
                        </Button>
                        <Button
                            disabled={disableButton}
                            variant="outlined"
                            type="submit"
                            onClick={() => handleCancel()}
                        >
                            Cancel
                        </Button>
                        <Typography sx={{ flexGrow: 1 }} />
                        {/* <Button
                            disabled={disableButton}
                            variant="outlined"
                            type="submit"
                            onClick={() => {
                                setDisableButton(true);
                                dispatch(privateDBCreate({ userId: "" }))
                                setTimeout(() => {

                                    setDisableButton(false);
                                    navi("/privatedb/list");
                                }, 5000)
                            }
                            }
                            color={'warning'}
                        >
                            Unassign
                        </Button> */}
                    </CardActions>
                </Card>
            </Container>
        </React.Fragment>
    )


}

export default PrivateDBAssign;